module.exports = __webpack_public_path__ + "img/index-logo.9299ac51.png";